<hlm-dialog [state]="state()" (closed)="onCancel()">
  <hlm-dialog-content
    *brnDialogContent="let ctx"
    class="w-[min(48rem,calc(100vw-2rem))] md:w-[min(48rem,calc(100vw-2rem))] max-w-none min-w-0 h-[700px] max-h-[90vh] flex flex-col"
  >
    <app-wizard-dialog-header
      eyebrow="Katalog · Modul"
      [title]="computedTitle()"
      [steps]="wizardSteps()"
      [showTimeline]="config().showTimeline !== false && totalSteps() > 1"
      (stepJump)="goToStep($event)"
    />

    <!-- Step Content -->
    <div hlmSeparator class="my-2"></div>
    <div class="flex-1 py-4 relative w-full min-h-0">
      <div class="h-full w-full transition-all duration-300 ease-in-out overflow-hidden">
        <div class="h-full overflow-y-auto animate-in fade-in-50 duration-300 px-1">
          <app-step-lead [text]="currentLead()" />

          <form [formGroup]="moduleForm">
            <!-- Step 1: Module Details -->
            @if (currentStep() === 1) {
              <div class="grid grid-cols-2 gap-5">
                <div class="col-span-2">
                  <app-suffix-input
                    label="Name"
                    inputType="text"
                    formControlName="name"
                    required
                    [errorText]="moduleForm.get('name')?.invalid && moduleForm.get('name')?.touched ? 'Name ist erforderlich (min. 3 Zeichen)' : null"
                  />
                </div>
                <app-suffix-input
                  label="Leistung"
                  suffix="kWp" [decimals]="2"

                  formControlName="power"
                  required
                  [errorText]="moduleForm.get('power')?.invalid && moduleForm.get('power')?.touched ? 'Leistung muss zwischen 0,05 und 10 kWp liegen' : null"
                />
                <app-suffix-input
                  label="Effizienzverlust"
                  suffix="%/Jahr" [decimals]="2"

                  formControlName="efficiencyLossPerYear"
                  required
                  [errorText]="moduleForm.get('efficiencyLossPerYear')?.invalid && moduleForm.get('efficiencyLossPerYear')?.touched ? 'Effizienzverlust muss zwischen 0 und 5 %/Jahr liegen' : null"
                />
                <app-suffix-input
                  label="Höhe"
                  suffix="cm"

                  formControlName="height"
                  required
                  [errorText]="moduleForm.get('height')?.invalid && moduleForm.get('height')?.touched ? 'Höhe muss zwischen 10 und 500 cm liegen' : null"
                />
                <app-suffix-input
                  label="Breite"
                  suffix="cm"

                  formControlName="width"
                  required
                  [errorText]="moduleForm.get('width')?.invalid && moduleForm.get('width')?.touched ? 'Breite muss zwischen 10 und 500 cm liegen' : null"
                />
                <div class="col-span-2">
                  <app-computed-total label="Modulfläche" [value]="(areaM2() | number: '1.2-2') + ' m²'" [emphasized]="false" />
                </div>
              </div>
            }

            <!-- Step 2: Costs -->
            @if (currentStep() === 2) {
              <div class="grid grid-cols-2 gap-5">
                <app-suffix-input label="Modulkosten" suffix="€" [decimals]="2" formControlName="costs" required [errorText]="moduleForm.get('costs')?.invalid && moduleForm.get('costs')?.touched ? 'Kosten dürfen nicht negativ sein' : null" />
                <app-suffix-input label="Installation" suffix="€" [decimals]="2" formControlName="installationCosts" required [errorText]="moduleForm.get('installationCosts')?.invalid && moduleForm.get('installationCosts')?.touched ? 'Kosten dürfen nicht negativ sein' : null" />
                <app-suffix-input label="Montagesystem" suffix="€" [decimals]="2" formControlName="mountingSystemCosts" required [errorText]="moduleForm.get('mountingSystemCosts')?.invalid && moduleForm.get('mountingSystemCosts')?.touched ? 'Kosten dürfen nicht negativ sein' : null" />
                <div class="col-span-2">
                  <app-computed-total label="Gesamtkosten je Modul" [value]="(totalCosts() | number: '1.2-2') + ' €'" />
                </div>
              </div>
            }

            <!-- Step 3: Review & Confirm -->
            @if (currentStep() === 3) {
              <div class="flex flex-col gap-6">
                <app-summary-section title="Moduldetails" (edit)="jumpToStep(1)">
                  <app-summary-row label="Name" [value]="moduleForm.get('name')?.value || '—'" />
                  <app-summary-row label="Leistung" [value]="(moduleForm.get('power')?.value || '—') + ' kWp'" mono />
                  <app-summary-row label="Abmessungen" [value]="(moduleForm.get('height')?.value || '—') + ' × ' + (moduleForm.get('width')?.value || '—') + ' cm'" mono />
                  <app-summary-row label="Fläche" [value]="(areaM2() | number: '1.2-2') + ' m²'" mono />
                  <app-summary-row label="Effizienzverlust" [value]="(moduleForm.get('efficiencyLossPerYear')?.value ?? '—') + ' %/Jahr'" mono />
                </app-summary-section>
                <app-summary-section title="Kosten" (edit)="jumpToStep(2)">
                  <app-summary-row label="Modulkosten" [value]="(moduleForm.get('costs')?.value | number: '1.2-2') + ' €'" mono />
                  <app-summary-row label="Installation" [value]="(moduleForm.get('installationCosts')?.value | number: '1.2-2') + ' €'" mono />
                  <app-summary-row label="Montagesystem" [value]="(moduleForm.get('mountingSystemCosts')?.value | number: '1.2-2') + ' €'" mono />
                  <app-summary-row label="Gesamtkosten" [value]="(totalCosts() | number: '1.2-2') + ' €'" mono />
                </app-summary-section>
                <p class="text-xs text-muted-foreground">
                  Prüfen Sie die Angaben und klicken Sie auf „{{ computedSubmitButtonText() }}", um das Modul zu speichern.
                </p>
              </div>
            }
          </form>

          <!-- Error Message -->
          @if (error()) {
            <div class="mt-4 px-3.5 py-3 flex items-start gap-2.5 bg-destructive/10 border border-destructive/20 rounded-lg">
              <p class="text-sm text-destructive">{{ error() }}</p>
            </div>
          }
        </div>
      </div>
    </div>

    <div hlmSeparator></div>
    <app-wizard-dialog-footer
      [currentStep]="currentStep()"
      [totalSteps]="totalSteps()"
      [isFirstStep]="isFirstStep()"
      [isLastStep]="isLastStep()"
      [canProceed]="canProceedFromCurrentStep()"
      [isSubmitting]="isSubmitting()"
      [submitLabel]="computedSubmitButtonText()"
      (back)="prevStep()"
      (next)="nextStep()"
      (submit)="onSubmit(ctx)"
    />
  </hlm-dialog-content>
</hlm-dialog>
